import { DateTime } from "luxon";
import { create } from "zustand";

const defaultPeriod = "day";
const periodDisplayNames = {
    day: "Day",
    week: "Week",
    month: "Month",
};

const defaultReportRange = {
    day: {
        start: DateTime.now()
            .startOf("day")
            .minus({ days: 90 })
            .startOf("month")
            .toISODate(),
        end: DateTime.now().startOf("day").toISODate(),
    },
    week: {
        start: DateTime.now().startOf("week").minus({ weeks: 28 }).toISODate(),
        end: DateTime.now().startOf("week").toISODate(),
    },
    month: {
        start: DateTime.now()
            .startOf("month")
            .minus({ months: 12 })
            .toISODate(),
        end: DateTime.now().startOf("month").toISODate(),
    },
};

const useLinkStore = create((set, get) => ({
    setPeriod(period) {
        set((state) => ({
            period,
            displayPeriod: periodDisplayNames[period],
        }));
    },
    period: defaultPeriod,
    displayPeriod: periodDisplayNames[defaultPeriod],
    reportRange: defaultReportRange[defaultPeriod],
    setReportRange: (start, end) =>
        set((state) => ({
            reportRange: {
                start,
                end,
            },
        })),
    linkWindow: 1,
    setLinkWindow: (linkWindow) => set({ linkWindow }),
    setOpenPromotion: (openPromotionID, openPlacementID) =>
        set({ openPromotionID, openPlacementID }),
}));

export const useLinkWindow = () => useLinkStore((state) => state.linkWindow);
export const useOpenPromotion = () =>
    useLinkStore((state) => [
        state.openPromotionID,
        state.openPlacementID,
        state.setOpenPromotion,
    ]);
export const usePeriod = () => useLinkStore((state) => state.period);
export const useReportRange = () => useLinkStore((state) => state.reportRange);
